// src/components/common/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that automatically scrolls to top on route change
 * Should be placed inside Router but outside Routes
 * Now handles anchor links properly
 */
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to top if there's no hash fragment
    // This allows anchor links to work properly
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;